export const ModalConstants = {
  UNSUBSCRIBE_MODAL_STEPS: {
    EMAIL_PHONE: 1,
    OTP: 2,
  },
  OTP: {
    LENGTH: 4,
    TIMER_SECONDS: 20,
  },
  MESSAGES: {
    REQUEST_PROCESSED: "Request processed",
    SOMETHING_WRONG: "Something went wrong, please try again.",
    OTP_SENT: "OTP sent successfully",
    REQUEST_FAILED: "Failed to process request. Please try again.",
    INVALID_OTP: "Please enter a valid 4-digit OTP",
    UNSUBSCRIBE_SUCCESS: "You have been unsubscribed successfully",
    OTP_VERIFICATION_FAILED: "OTP verification failed. Please try again.",
  },
  LABELS: {
    EMAIL_PHONE: "Enter Email/Phone",
    REQUIRED_MARK: "*",
    OTP_SENT_TO: "OTP sent to",
  },
  PLACEHOLDERS: {
    EMAIL_PHONE: "Enter Email/Phone",
  },
  BUTTON_TEXT: {
    UNSUBSCRIBE: "Unsubscribe",
    PROCESSING: "Processing...",
    VERIFY: "Verify",
    VERIFYING: "Verifying...",
  },
  TITLES: {
    UNSUBSCRIPTION: "Unsubscription",
  },
  DESCRIPTIONS: {
    STEP_ONE: "Please enter your details to unsubscribe from promotional sms/email",
    STEP_TWO: "Enter OTP",
  },
  STATUS: {
    SUCCESS: "success",
  },
  FROM_WHERE: {
    FOOTER: "footer",
  },
  DELAYS: {
    VERIFICATION: 800,
  },
};